import { memo, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import CustomButton from '../../../common/CustomButton/CustomButton';
import { Icon } from '../../../common/Icon/Icon';
import Markdown from '../../../common/Markdown/Markdown';
import { slugify } from '../../../core/helpers';

interface IProps {
  item: {
    question: string;
    answer: string;
  };
  isOpen: boolean;
  str: string;
  handleToggle(str: string): void;
}

const Item = memo(({ item, isOpen, str, handleToggle }: IProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.setProperty('--support-item-height', `${ref.current?.scrollHeight}px`);
  }, [isOpen]);

  return (
    <div className={`support__question${isOpen ? ' open' : ''}`} key={item.question}>
      <CustomButton
        className="support__btn h4"
        type="button"
        onClick={() => handleToggle(str)}
        id={slugify(item.question)}
      >
        {item.question}
        <Icon.Chevron className={`${isOpen ? 'flip-y' : ''}`} />
      </CustomButton>
      <CSSTransition
        nodeRef={ref}
        in={isOpen}
        timeout={3000}
        classNames="support-body"
        unmountOnExit
      >
        <div className="support__body" ref={ref}>
          <Markdown className="support__body-content markdown">{item.answer}</Markdown>
        </div>
      </CSSTransition>
    </div>
  );
});

export default Item;
